import { Injectable } from '@angular/core';
import { HandlerService } from '../../handlers/handlers.service';
import { MethodsService } from '../method.service';
import { environment as params } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SuscribeWPService extends MethodsService {
  constructor(_HandlerService: HandlerService, http: HttpClient) {
    super(_HandlerService, http);
    this.setApi((<any>params).api.wp);
  }
  setNewSuscription($data: any) {
    return this.post('apimj/suscribe/new', $data);
  }
  validaEmail(email: string) {
    return this.post('apimj/suscribe/valida/email', {email: email});
  }
}
